import { formatMoney } from 'accounting'

import type { EntitiesState } from '@redux/entities'

import { InvoiceModel } from '@models/types'

import { baseURL } from './api'

interface GetInvoiceDownloadUrlParams {
  invoice: InvoiceModel,
  invoiceAttachments: EntitiesState['invoiceAttachments'],
}

export const getInvoiceDownloadUrl = (
  params: GetInvoiceDownloadUrlParams,
) => {
  const { invoice, invoiceAttachments } = params

  const {
    attachments, created_by, id,
  } = invoice

  // @ts-expect-error TS18048
  if (created_by === 'debtor' && attachments?.length > 0){
    // @ts-expect-error TS18048
    const attachment = invoiceAttachments[attachments[0].id]

    // @ts-expect-error TS2339
    if (attachment?.links){
      // @ts-expect-error TS2339
      return attachment.links.file_url
    }
  }

  if (created_by !== 'debtor'){
    return `${baseURL}/invoices/${id}/pdf.json`
  }

  return null
}

interface InvoicePaymentStatusParams {
  amount_paid: number,
  paid: boolean,
  total: number,
}
export const invoicePaymentStatus = (params: InvoicePaymentStatusParams) => {
  const { total, paid, amount_paid } = params
  const paymentRemaining = formatMoney(total - amount_paid)

  if (paid){
    return 'Paid'
  }
  if (!paid && amount_paid > 0){
    return `Partially Paid (${paymentRemaining} Owing)`
  }

  return 'Unpaid'
}

export const matchFilterBrand = (
  invoice: InvoiceModel,
  agencies: EntitiesState['agencies'],
  filterBrandId?: number,
) => {
  const { debtor_id, debtor_type } = invoice

  if (!filterBrandId) return true

  const agency = debtor_type === 'Agency' && debtor_id ? agencies[debtor_id] : undefined
  const matchAgency = agency?.brand_id === filterBrandId

  return matchAgency
}

export const getInvoiceStatus = (invoice: InvoiceModel) => {
  if (invoice.void) return 'Void'
  if (invoice.paid) return 'Paid'
  return 'Approved'
}
